import React from "react";

function FlContent({ children }) {
    return <div className="fl contentWrap">{children}</div>;
}

export default FlContent;
